export interface ChartColors {
  revenue: string;
  spend: string;
  profit: string;
  installs: string;
  clicks: string;
  grid: string;
  tooltipBg: string;
  tooltipBorder: string;
  axisText: string;
  legendText: string;
  gradients: {
    revenue: [string, string];
    spend: [string, string];
    profit: [string, string];
  };
}

export function getChartColors(isDark: boolean): ChartColors {
  if (isDark) {
    return {
      revenue: "#34d399",
      spend: "#f87171",
      profit: "#a5b4fc",
      installs: "#60a5fa",
      clicks: "#34d399",
      grid: "rgba(255, 255, 255, 0.07)",
      tooltipBg: "#1e1e1e",
      tooltipBorder: "#333333",
      axisText: "#9ca3af",
      legendText: "#d1d5db",
      gradients: {
        revenue: ["rgba(52, 211, 153, 0.30)", "rgba(52, 211, 153, 0)"],
        spend: ["rgba(248, 113, 113, 0.20)", "rgba(248, 113, 113, 0)"],
        profit: ["rgba(165, 180, 252, 0.30)", "rgba(165, 180, 252, 0)"],
      },
    };
  }
  return {
    revenue: "#22c55e",
    spend: "#ef4444",
    profit: "#818cf8",
    installs: "#3b82f6",
    clicks: "#10b981",
    grid: "rgba(0, 0, 0, 0.07)",
    tooltipBg: "#1e1e1e",
    tooltipBorder: "#333333",
    axisText: "#6b7280",
    legendText: "#374151",
    gradients: {
      revenue: ["rgba(34, 197, 94, 0.35)", "rgba(34, 197, 94, 0)"],
      spend: ["rgba(239, 68, 68, 0.20)", "rgba(239, 68, 68, 0)"],
      profit: ["rgba(129, 140, 248, 0.35)", "rgba(129, 140, 248, 0)"],
    },
  };
}
